<script setup lang="ts">
/** 接收 Nuxt 错误边界注入的错误对象，避免 fragment 根节点透传属性告警。 */
defineProps<{ error?: unknown }>()
</script>

<template>
  <NuxtLayout :force-default-top-nav="true">
    <CommonNotFound class="is-error-404" />
  </NuxtLayout>
  <DevSsrRequestInspector trigger-position="left" :clear-on-route-change="false" />
</template>
